import React, { useState, useEffect } from 'react'
import { Link, useLocation, useHistory } from 'react-router-dom'
import Api from '../../../helpers/Api'


//partials
import Table from './partials/Table'
import Filter from './partials/Filter'
import Pagination from '../../partials/Pagination'

//styles
import '../../../assets/css/outlets.css'

//images
import loader from '../../../assets/img/app/loader.svg'
import { useAuthContext } from '../../../contexts/AuthContext'
import TableProcedures from './partials/TableProcedures'

let timeout

function Index(props) {
    const location = useLocation()
    const history = useHistory()
    const auth = useAuthContext()

    const searchParams = new URLSearchParams(location.search)

    const tabGroup = searchParams.get('current')
        ? 'current'
        :
        searchParams.get('companies')
            ? 'companies'
            : searchParams.get('persons')
                ? 'persons'
                : ''

    if (tabGroup === '') {
        history.replace('/obligations?current=1&page=1')
    }

    const [data, setData] = useState({
        items: [],
        current: [],
        pages: 1,
        page: searchParams.get('page') || 1,
        total: 0,
        count: 0,
        procedures: 0,
        loading: true,
        refresh: false,
        filter: {
            id: searchParams.get('id') || '',
            requestNo: searchParams.get('requestNo') || '',
            protocolNo: searchParams.get('protocolNo') || '',
            certificateNo: searchParams.get('certificateNo') || '',
            company: searchParams.get('company') || '',
            applicant: searchParams.get('applicant') || '',
            eik: searchParams.get('eik') || '',
            egn: searchParams.get('egn') || '',
            // startDate: searchParams.get('startDate') || '',
            // endDate: searchParams.get('endDate') || '',
            sort: searchParams.get('sort') || ''
        }
    })

    useEffect(() => {
        loadData()

        let url = location.pathname + '?' + tabGroup + '=1';

        Object.entries(data.filter).forEach((p, i) => {
            if (p[1]) url += '&' + (p[0] + '=' + p[1])
        })

        if (data.refresh) {
            url += (url.indexOf('?') > -1 ? '&' : '?') + 'reload=' + data.refresh
        }

        url += (url.indexOf('?') > -1 ? '&' : '?') + 'page=' + data.page

        history.replace(url)

    }, [tabGroup, data.filter, data.refresh, data.page])

    useEffect(() => {
        return clearTimeout(timeout)
    }, [])

    const loadData = () => {

        if (!tabGroup) {
            return;
        }

        setData(prev => ({
            ...prev,
            loading: true
        }))

        let url = 'procedures/obligations'
            + '?group=' + tabGroup
            + '&requestNo=' + data.filter.requestNo
            + '&protocolNo=' + data.filter.protocolNo
            + '&certificateNo=' + data.filter.certificateNo
            + '&applicant=' + data.filter.applicant
            + '&company=' + data.filter.company
            + '&eik=' + data.filter.eik
            + '&egn=' + data.filter.egn
            // + '&startDate=' + data.filter.startDate
            // + '&endDate=' + data.filter.endDate
            + '&sort=' + data.filter.sort
            + '&page=' + data.page

        Api.get(url)
            .then(res => {
                setData(prev => ({
                    ...prev,
                    items: res.data.items,
                    current: res.data.items,
                    pages: res.data.pages,
                    total: res.data.total,
                    count: res.data.count,
                    loading: false
                }))
            })
    }

    const refreshData = () => {
        setData(prev => ({
            ...prev,
            refresh: new Date().getTime(),
            loading: true,
            page: 1,
            total: 0,
            count: 0,
            procedures: 0,
            items: []
        }))
    }

    const filterData = (e, name, val, timeoutDuration = 0) => {
        e.preventDefault()

        clearTimeout(timeout)

        timeout = setTimeout(() => {
            setData(prev => ({
                ...prev,
                page: 1,
                filter: {
                    ...prev.filter,
                    [name]: val
                }
            }))
        }, timeoutDuration)

    }

    const handlePage = page => setData(prev => ({ ...prev, page: page.selected + 1 }))

    return (
        <section id="outlets">
            <div className="wrapper top row">
                <h1>
                    {tabGroup === 'current'
                        ? 'В процес на изпълнение'
                        : `Издадени удостоверения ${tabGroup === 'companies' ? 'към фирми' : 'към физически лица'}`
                    }
                </h1>

                <button className="btn-add multiple-add">
                    Ново
                        <ul>
                        <li>
                            <Link to="/obligations/create/position">
                                Ново становище
                            </Link>
                        </li>
                        <li>
                            <Link to="/obligations/create/notification">
                                Ново уведомление
                            </Link>
                        </li>
                    </ul>
                </button>



            </div>
            <div className="wrapper">
                <div className="row">
                    <Filter
                        tabGroup={tabGroup}
                        filter={data.filter}
                        filterData={filterData}
                    />
                </div>
                {data.loading
                    ?
                    <img src={loader} alt="loading" />
                    : data.current.length === 0 && data.items.length === 0
                        ? <p className="no-info">
                            Няма намерени данни
                        </p>
                        :
                        <>
                            <div className="row">
                                {tabGroup === 'current'
                                    ?
                                    <TableProcedures
                                        tabGroup={tabGroup}
                                        data={data.current}
                                        selected={data.filter.id}
                                        refreshData={refreshData}
                                    />
                                    :
                                    <Table
                                        tabGroup={tabGroup}
                                        data={data.items}
                                        selected={data.filter.id}
                                        refreshData={refreshData}
                                    />
                                }
                            </div>
                            <div className="row">
                                <Pagination
                                    page={data.page}
                                    pages={data.pages}
                                    handlePage={handlePage}
                                />
                            </div>
                        </>
                }
            </div>

        </section>
    )
}

export default Index